import React, { type ReactNode } from 'react';
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from '../primitives/tooltip';

interface TooltipButtonProps {
    children: ReactNode;
    text: string;
    side?: 'bottom' | 'top' | 'right' | 'left';
    asChild?: boolean;
}

const TooltipButton: React.FC<TooltipButtonProps> = ({
    children,
    text,
    side = 'bottom',
    asChild = true,
}) => {
    return (
        <TooltipProvider delayDuration={150}>
            <Tooltip>
                <TooltipTrigger asChild={asChild}>{children}</TooltipTrigger>
                <TooltipContent side={side} className="bg-black text-white">
                    <p className="text-xs font-semibold">{text}</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};

export default TooltipButton;
